export default __webpack_public_path__ + "static/media/amor-propio-2-min.cea634e0.jpg";